module.exports = __webpack_public_path__ + "static/img/Frame 18163.98243b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/Frame 18163.png
// module id = lpw6
// module chunks = 12